<template>
  <div class="pageContol">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">数据中心</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">重考审核</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">审核</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-form ref="ruleForm" class="ruleForm" :rules="rules" :model="ruleForm" label-width="100px" size="small"
              style="width: 500px;">
              <div class="fromTitle">基本信息</div>
              <el-form-item label="考核日期:" prop="examinationDate">
                <el-date-picker size="small" v-model="ruleForm.examinationDate" type="date" value="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择日期" disabled>
                </el-date-picker>
              </el-form-item>
              <el-form-item label="作业类别:" prop="workCategory">
                <el-select size="small" v-model="ruleForm.workCategory" clearable placeholder="请选择作业类别"
                  :disabled="lastPageData.applyId != ''">
                  <el-option v-for="item in workCategoryList" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="考生信息" prop="examinationUserId">
                <el-select v-model="ruleForm.examinationUserId" placeholder="请选择" no-data-text="没有数据" remote
                  size="small" clearable :remote-method="getExamineeInformation"
                  @visible-change="clearExamineeInformation" :disabled="lastPageData.applyId != ''">
                  <template>
                    <div class="select-header">
                      <span style="
                        color: #8492a6;
                        float: left;
                        font-size: 13px;
                        width: 100px;
                      ">学员姓名</span>
                      <span style="
                        color: #8492a6;
                        float: left;
                        font-size: 13px;
                        margin-left: 50px;
                        width: 140px;
                      ">身份证号码</span>
                    </div>
                    <div class="select-header">
                      <el-input v-model="ruleForm.fullName" v-on:input="getExamineeInformation" type="text" size="small"
                        placeholder="学员姓名" clearable style="width: 100px" />
                      <el-input v-model="ruleForm.idCard" v-on:input="getExamineeInformation" type="text" size="small"
                        placeholder="身份证号码" clearable style="margin-left: 50px; width: 140px" />
                    </div>
                  </template>
                  <el-option v-for="(item, index) in userList" :key="index" :label="item.fullName + '-' + item.idCard"
                    :value="item.examinationUserId">
                    <span style="width: 100px; font-size: 13px">{{ item.fullName }}</span>
                    <span style="width: 140px; margin-left: 50px; font-size: 13px">{{ item.idCard }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="申请材料" required>
                <p v-for="(item, index) in ruleForm.applyMaterials" :key="index">{{ item.materialName }}
                  <el-button type="text" @click="previewFile(item)">预览</el-button>
                </p>
              </el-form-item>
              <el-form-item>
                <el-button class="bgc-bv" @click="$router.back()">取 消</el-button>
                <el-button class="bgc-bv" @click="setExamine_Pass_open('30')">通 过</el-button>
                <el-button class="bgc-bv" @click="setExamine_noPass_open('40')">驳 回</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传材料 - 预览 -->
    <el-dialog title="上传材料 - 预览" :visible.sync="formUploadMaterialsPreview.dialogVisible" @close="uploadLodClose"
      :modal="false" width="50%" top="2%" center v-dialogDrag>
      <div class="ovy-a" style="height: 600px">
        <div id="pdf-cert1" style="height: 600px"
          v-if="formUploadMaterialsPreview.fileType == 'pdf' || formUploadMaterialsPreview.fileType == 'PDF'"></div>
        <div v-else>
          <img :src="formUploadMaterialsPreview.materialUrl" alt="" width="100%" height="100%" />
        </div>
      </div>
    </el-dialog>
    <!-- 通过 -->
    <el-dialog title="提示" :visible.sync="examine_Pass_data.dialogVisible" width="600px" center
      @close="setExamine_noPass_close">
      <p>请仔细确认实操考生: <span style="color: red;"> {{ ruleForm.fullName }} [{{ ruleForm.idCard }}] </span>符合重考要求，一经确认，系统将清空考生今天的所有考试信息，不可恢复。</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setExamine_Pass_close">取消</el-button>
        <el-button @click="setExamine_Pass_open_ok" class="bgc-bv">确定</el-button>
      </span>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog title="驳回原因" :visible.sync="examine_noPass_data.dialogVisible" width="600px"
      @close="setExamine_noPass_close">
      <el-form ref="examine_noPass_data" :model="examine_noPass_data" :rules="examine_noPass_data_rules" size="small"
        label-width="100px">
        <el-form-item label="驳回原因" prop="auditDesc">
          <el-input type="textarea" placeholder="请输入驳回原因" maxlength="255" show-word-limit
            v-model="examine_noPass_data.auditDesc"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setExamine_noPass_open_ok" class="bgc-bv">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pdf from "pdfobject";
import { acceptTypeImg } from "@/utils/common";
export default {
  name: "examinationAffairsManage_reexaminationReviewInfo",
  data() {
    return {
      // 上个页面的数据
      lastPageData: {
        applyId: "",  // 重考申请id
      },
      // 基本信息
      ruleForm: {
        examinationDate: new Date(new Date().getTime()).Format('yy-MM-dd'), // 考试日期
        workCategory: "", // 作业类别
        examinationUserId: "", // 考生学员id
        fullName: "", // 考生学员
        idCard: "", // 考生身份证号
        applyMaterials: [], // 申请材料
      },
      // 作业类别 - 下拉数据
      workCategoryList: [],
      // 考生列表
      userList: [],
      // 基本信息 - 数据校验
      rules: {
        examinationDate: [
          { required: true, trigger: "change", message: "请选择考试日期" }
        ],
        workCategory: [
          { required: true, trigger: "change", message: "请选择作业类别" }
        ],
        examinationUserId: [
          { required: true, trigger: "change", message: "请选择考生信息" }
        ],
      },
      // 上传材料 - 预览材料 - 弹框数据
      formUploadMaterialsPreview: {
        dialogVisible: false, // 弹窗状态
        fileType: "", // 文件类型
        materialUrl: "", // 预览图片的地址
      },
      // 通过 - 弹框数据
      examine_Pass_data: {
        dialogVisible: false, // 弹框状态
      },
      // 驳回 - 弹框数据
      examine_noPass_data: {
        dialogVisible: false, // 弹框状态
        auditDesc: "", // 审核备注
      },
      // 驳回 - 弹框数据 - 校验
      examine_noPass_data_rules: {
        auditDesc: [
          { required: true, message: "请输入驳回原因", trigger: "blur" }
        ],
      },
    };
  },
  created() {
    this.lastPageData.applyId = this.$route.query?.applyId ?? "";
    this.getDictionary();
    if (this.lastPageData.applyId) {
      this.getDetail();
    }
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 字典
    getDictionary() {
      // 作业类别
      let workCategory = this.$setDictionary("PA_WORK_CATEGORY", "list");
      for (const key in workCategory) {
        this.workCategoryList.push({
          value: key,
          label: workCategory[key],
        });
      }
    },
    // 获取 - 考生信息
    getExamineeInformation() {
      // 考试日期 && 作业类别 同时选择才可查
      if (this.ruleForm.examinationDate && this.ruleForm.workCategory) {
        this.$post("/biz/plan/pa-plan-examination-user/query/list", {
          pageNum: 1, //每次都只要第一页
          pageSize: 5, //根据次参数控制显示的数据行数，尽量不出现滚动条
          examinationDate: this.ruleForm.examinationDate, // 考试日期
          workCategory: this.ruleForm.workCategory, // 作业类别
          fullName: this.ruleForm.fullName, // 考生姓名
          idCard: this.ruleForm.idCard, // 身份证
        }, 3000, true, 10).then((res) => {
          if (res.data.length) {
            this.userList = res.data;
          } else {
            this.userList = [{}];
          }
          // 编辑 - 手搓一个下拉数据
          if (this.lastPageData.applyId) {
            this.userList = [...this.userList, ...[{
              examinationUserId: this.ruleForm.examinationUserId,
              fullName: this.ruleForm.fullName,
              idCard: this.ruleForm.idCard,
            }]]
          }
        });
      } else {
        this.$message.warning("请同时选择：“考试日期” 和 “作业类别”");
      }
    },
    // 清除 - 考生信息
    clearExamineeInformation(e) {
      if (e) {
        this.ruleForm.fullName = "";
        this.ruleForm.idCard = "";
        this.userList = [];
        this.getExamineeInformation();
      }
    },
    // 获取 - 详情
    getDetail() {
      this.$post("/biz/plan/resit/apply/info", {
        applyId: this.lastPageData.applyId
      }, 3000, true, 10).then((res) => {
        for (let i = 0; i < res.data.materialBOS.length; i++) {
          res.data.materialBOS[i].name = res.data.materialBOS[i].materialName;
          res.data.materialBOS[i].url = res.data.materialBOS[i].materialUrl;
        }
        res.data.applyMaterials = res.data.materialBOS;
        delete res.data.materialBOS;
        this.ruleForm = { ...this.ruleForm, ...res.data };
        this.getExamineeInformation();
      });
    },
    // 上传材料 - 预览文件
    previewFile(res) {
      let extension = res.materialKey.replace(/.+\./, "");
      this.formUploadMaterialsPreview.fileType = extension;
      if (extension == "pdf" || extension == "PDF") {
        this.$nextTick(() => {
          pdf.embed(res.materialUrl, "#pdf-cert1");
        });
      } else {
        this.formUploadMaterialsPreview.materialUrl = res.materialUrl;
      }
      this.formUploadMaterialsPreview.dialogVisible = true;
    },
    // 上传材料 - 关闭弹窗
    closeUploadMaterials() {
      this.formUploadMaterials = this.$options.data().formUploadMaterials;
    },
    // 审核 - 通过 - 打开弹框
    setExamine_Pass_open() {
      this.examine_Pass_data.dialogVisible = true;
    },
    // 审核 - 通过 - 打开弹框 - 确定
    setExamine_Pass_open_ok() {
      this.$post('/biz/plan/resit/apply/audit', {
        applyId: this.lastPageData.applyId,
        auditState: '40'
      }, 3000, true, 10).then((res) => {
        this.$message.success('操作成功')
        this.$router.back();
      })
        .catch((err) => {
          return;
        });
    },
    // 审核 - 通过 - 关闭弹框
    setExamine_Pass_close() {
      this.examine_Pass_data = this.$options.data().examine_Pass_data;
    },
    // 审核 - 驳回 - 打开弹框
    setExamine_noPass_open() {
      this.examine_noPass_data.dialogVisible = true;
    },
    // 审核 - 驳回 - 打开弹框 - 确定
    setExamine_noPass_open_ok() {
      this.$refs['examine_noPass_data'].validate((valid) => {
        if (valid) {
          this.$post('/biz/plan/resit/apply/audit', {
            applyId: this.lastPageData.applyId,
            auditState: '30',
            auditDesc: this.examine_noPass_data.auditDesc
          }, 3000, true, 10).then((res) => {
            this.setExamine_noPass_close();
            this.$message.success('操作成功')
            this.$router.back();
          })
            .catch((err) => {
              return;
            });
        }
      });
    },
    // 审核 - 驳回 - 关闭弹框
    setExamine_noPass_close() {
      this.examine_noPass_data = this.$options.data().examine_noPass_data;
    },
  }
};
</script>
<style lang="less" scoped>
.select-header {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #606266;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}

.ruleForm {
  .fromTitle {
    font-size: 18px;
    margin-bottom: 20px;
  }
}
</style>